import * as yup from "yup";
import { Generic } from "../";
import { ContactTypes } from "../../domain";
import { ReactSelectOption } from "../../models/generic";
import { BasicOrganizationProfile } from "../../models/organization";
import { FormValidationModel } from "../../models/validation";
import "../../utils/YupHelper";
import { DefaultUSCountry, ReactSelectOptionSchema } from "../generic";

export interface CreateAccountData {
    name: Generic.FullNameSuffixData;
    degrees?: string;
    existingUserId?: number;
    title?: string;
    organization: ReactSelectOption | BasicOrganizationProfile | null;
    organizationId?: number;
    department?: string;
    address: Generic.AddressData;
    phone: Generic.PhoneNumberData;
    username: string;
    password: string;
    confirmPassword: string;
}

export class CreateAccount implements FormValidationModel<CreateAccountData> {
    public data: CreateAccountData;
    public rules: yup.Schema<CreateAccountData>;

    public constructor() {
        this.data = {
            name: {},
            organization: null,
            address: {
                contactTypeId: ContactTypes.Business.id,
                countryCode: DefaultUSCountry,
            },
            phone: {
                contactTypeId: ContactTypes.Business.id,
                countryCode: DefaultUSCountry,
                number: "",
            },
            username: "",
            password: "",
            confirmPassword: "",
        };
        this.rules = yup.object<CreateAccountData>().shape({
            name: Generic.FullNameSuffixRequiredSchema.required(),
            degrees: yup.string().label("Degrees").max(50),
            existingUserId: yup.number(),
            title: yup.string().label("Title").max(100),
            organization: ReactSelectOptionSchema.required().notOneOf([undefined]).label("Organization"),
            organizationId: yup.number().min(0).label("Organization"),
            department: yup.string().label("Department").max(250),
            address: Generic.AddressSchemaRequired.required(),
            phone: Generic.PhoneNumberSchemaRequired.required(),
            username: yup.string().email().required().label("Username").max(50),
            password: yup.string().required().label("Password").min(8).max(50),
            confirmPassword: (yup.string().required().label("Confirm password").max(50) as any)
                .equalTo(yup.ref("password"), "Password and confirm password fields do not match"),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/account/CreateAccount.ts